// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MMYZZJ {
  display: flex;
  justify-content: flex-end;
}
.nBhT5f {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-1-5);
  border: 0;
  background: transparent;
  padding: 0;
  border-radius: var(--radius-s);
  cursor: pointer;
}

.nBhT5f:disabled {
  cursor: default;
}

.nBhT5f:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 2px;
}

.yH6tOa {
  display: grid;
  place-items: center;
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
}

.YpY99r {
  position: relative;
  flex: 0 0 72.099px;
  width: 72.099px;
  height: 36.519px;
}

.xEgLNw,
.o2TkyL {
  position: absolute;
  display: block;
  max-width: none;
  pointer-events: none;
  border-radius: 4px;
}

.xEgLNw {
  left: 0;
}

.w8sFT1 .xEgLNw {
  top: 0;
  width: 58.601px;
  height: 36.519px;
}

.w8sFT1 .o2TkyL {
  top: 3px;
  left: 6.099px;
  width: 58.498px;
  height: 36.455px;
}

.qlbnon .xEgLNw {
  top: 0.032px;
  width: 58.498px;
  height: 36.455px;
}

.qlbnon .o2TkyL {
  top: 4px;
  left: 7.099px;
  width: 58.601px;
  height: 36.519px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BenefitsModelSwitch/BenefitsModelSwitch.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,MAAM;EACN,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".container {\n  display: flex;\n  justify-content: flex-end;\n}\n.button {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  border: 0;\n  background: transparent;\n  padding: 0;\n  border-radius: var(--radius-s);\n  cursor: pointer;\n}\n\n.button:disabled {\n  cursor: default;\n}\n\n.button:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 2px;\n}\n\n.swapSlot {\n  display: grid;\n  place-items: center;\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.cards {\n  position: relative;\n  flex: 0 0 72.099px;\n  width: 72.099px;\n  height: 36.519px;\n}\n\n.backgroundCard,\n.foregroundCard {\n  position: absolute;\n  display: block;\n  max-width: none;\n  pointer-events: none;\n  border-radius: 4px;\n}\n\n.backgroundCard {\n  left: 0;\n}\n\n.emissor .backgroundCard {\n  top: 0;\n  width: 58.601px;\n  height: 36.519px;\n}\n\n.emissor .foregroundCard {\n  top: 3px;\n  left: 6.099px;\n  width: 58.498px;\n  height: 36.455px;\n}\n\n.vr .backgroundCard {\n  top: 0.032px;\n  width: 58.498px;\n  height: 36.455px;\n}\n\n.vr .foregroundCard {\n  top: 4px;\n  left: 7.099px;\n  width: 58.601px;\n  height: 36.519px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MMYZZJ`,
	"button": `nBhT5f`,
	"swapSlot": `yH6tOa`,
	"cards": `YpY99r`,
	"backgroundCard": `xEgLNw`,
	"foregroundCard": `o2TkyL`,
	"emissor": `w8sFT1`,
	"vr": `qlbnon`
};
module.exports = ___CSS_LOADER_EXPORT___;
